import { z } from '@repo/schema'

export const changePasswordSchema = z
  .object({
    password: z
      .string({ message: 'Please enter your password' })
      .min(8, { message: 'Password must be at least 8 characters' }),
    passwordConfirmation: z
      .string({ message: 'Please confirm your password' })
      .min(8, { message: 'Password must be at least 8 characters' }),
  })
  .refine(data => data.password === data.passwordConfirmation, {
    message: 'Passwords do not match',
    path: ['passwordConfirmation'],
  })
